var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"inputWrapper",staticClass:"uploadImgWrapper",on:{"click":_vm.uploadClick}}),(_vm.url)?_c('img',{staticClass:"uploadImg",attrs:{"src":_vm.url}}):_vm._e(),(_vm.loading)?_c('div',{staticClass:"loadingBox"},[_c('img',{staticClass:"loading",attrs:{"src":require("../../assets/loading.gif")}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }